<template>
  <div class="body">
    <Home-Header :navindex="5"></Home-Header>
    <Home-NewsDetail :article_id='id'></Home-NewsDetail>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a>

  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeNewsDetail from './components/NewsDetail'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'NewsDetail',
  components: {
    HomeHeader, HomeNewsDetail, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom
  },
  data () {
    return {
      id: this.$route.params.id
    }
  },
  created: function () {
    console.log(this.id, 'id')
  },
  mounted () {
    var articleId = this.$route.query.id
    console.log(this.id, 'id')
    console.log(articleId, 'articleId')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/News/NewsDetail.vue